export function syncIntercomIconVisibility({ hidden }) {
  const intercomIcon =
    document.querySelector('#intercom-container') ||
    document.querySelector('.intercom-lightweight-app');

  if (!intercomIcon) return;

  hidden ?
    intercomIcon.classList.add('tw-hidden')
  : intercomIcon.classList.remove('tw-hidden');
}

export function launchIntercomWithMessage(message) {
  window.Intercom('showNewMessage', message);
}
